export const isEmpty = (object) => {
    let isEmpty = true;
    for(var prop in object) {
        if(Object.prototype.hasOwnProperty.call(object, prop)) {
            isEmpty = false;
          //return false;
        }
    }
    return isEmpty;
}